import React from 'react';
import './style.scss';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            &#169; Diligent Equity {new Date().getFullYear()}
            <span hidden />
          </div>
          <div className="col-md-6 text-right">Private & Confidential</div>
        </div>
      </div>
    </footer>
  );
};
